import { useMemo } from "react";
import { get, isEmpty, map } from "lodash";
import "./patientNotes.scss";
import { getProgressColorCode } from "@pages/utils/utils";
import moment from "moment";
import { dateFormatConfig } from "@utils/constants";
import { getClientName, milleniumClientCheck } from "@utils/helpers";
import { NoDataFound } from "../programPage/programPage";
import { useCareCoordinationStore } from "@stores/useCareCoordinationStore";

export const PatientNotes = ({ data }: any) => {
  return (
    <div className="ui-patient-notes__notes">
      <div className="ui-patient-notes__notes__description" dangerouslySetInnerHTML={{ __html: data?.description }}></div>
      <div className="ui-patient-notes__notes__footer">
        {data?.createdBy ? (
          <>
            <div className="ui-patient-notes__notes__footer__createdBy">{data?.createdBy}</div>
            <div className="ui-patient-notes__notes__footer__partition">|</div>
          </>
        ) : null}
        <div className="ui-patient-notes__notes__footer__createdOn"> {moment(data?.createdOn)?.format(dateFormatConfig.get(getClientName())["dateTimeColumnFilterDisplayFormatWithTime"])}</div>
      </div>
    </div>
  );
};

export const CPSRNotes = ({ data, height, func }: any) => {
  return (
    <div className="ui-patient-notes">
      <div className="ui-patient-notes__header">
        <div className="ui-patient-notes__header__heading">{data?.title || "Patient Level Notes"}</div>
        {!isEmpty(data?.fromDate) && !isEmpty(data?.toDate) && (
          <div className="ui-patient-notes__header__dateRange">
            From: {data?.fromDate} To: {data?.toDate}
          </div>
        )}
      </div>
      {isEmpty(data?.notes) ? <NoDataFound /> : <></>}
      {map(data?.notes, (item, index) => {
        return <PatientNotes data={item} key={index} />;
      })}
      <hr className="ui-care-plan-report__division"></hr>
    </div>
  );
};

export const PhysicianCarePlan = ({ data , notesPayload}: any) => {

  const isMillenium = milleniumClientCheck();

  const physicianCarePlanNotes = useCareCoordinationStore((state) => state.physicianCarePlanNotes);

  const physicianNotesData = useMemo(() => {


    let physicianNotes = [];

    const startDate = get(notesPayload, "startDate");
    const endDate = get(notesPayload, "endDate");

    if(isMillenium) {
      if (get(notesPayload, "notesSelection") === "MostRecentNotes") {
        physicianNotes = [...physicianCarePlanNotes.slice(0, 5)];
      } else if (startDate && endDate) {
        physicianNotes = physicianCarePlanNotes.filter((n: any) => {
          return moment(n.notesCreateDate).isSameOrAfter(startDate.startOf("day")) && moment(n.notesCreateDate).isSameOrBefore(endDate.endOf("day"));
        });
      }
    
      physicianNotes = physicianNotes.map((d: any) => {
        return {
          description: d.notes,
          createdBy: `${d.careMgrLastName}, ${d.careMgrFirstName}`,
          createdOn: moment(d.notesCreateDate).utc().format(),
        };
      });
    
    }
  
    return {
      fromDate: startDate?.format("MM-DD-YYYY"),
      toDate: endDate?.format("MM-DD-YYYY"),
      notes: physicianNotes,
    }
  } ,[isMillenium, notesPayload, physicianCarePlanNotes] )

  
  return (
    <PhysicianCarePlanBody data={data} isMillenium={isMillenium} physicianNotesData={physicianNotesData}/>
  );
};

export function PhysicianCarePlanBody({ data, isMillenium, physicianNotesData }: any) {

  const title = 'Physician Care Plan';

  if (isMillenium) {
    return <CPSRNotes data={{...physicianNotesData , title}}/>;
  }

  return (
    <div className="ui-physician-care-plan-note">
      <div className="ui-physician-care-plan-note__header">
        <div className="ui-physician-care-plan-note__header__heading">{title}</div>
        {!isEmpty(data?.date) && <div className="ui-physician-care-plan-note__header__date">{moment(data?.date)?.format(dateFormatConfig.get(getClientName())["defaultDateFormat"])}</div>}
      </div>
      {isEmpty(data?.description) ? <NoDataFound /> : <div className="ui-physician-care-plan-note__description" dangerouslySetInnerHTML={{ __html: data?.description }}></div>}
      <hr className="ui-care-plan-report__division"></hr>
    </div>
  );
}

export const RiskScore = ({ data }: any) => {
  return (
    <div className="ui-care-plan-risk-score">
      <div className="ui-care-plan-risk-score__header">Risk Scores</div>
      <div className="ui-care-plan-risk-score__body">
        {isEmpty(data) && <NoDataFound />}
        {map(data, (item) => {
          return (
            <div key={item.label} className="ui-care-plan-risk-score__body__block">
              <div className="ui-care-plan-risk-score__body__block__data">
                <div className="ui-care-plan-risk-score__body__block__data__label"> {item?.label}</div>
                <div className="ui-care-plan-risk-score__body__block__data__value">{item?.value}%</div>
              </div>
              <div className="progress">
                <div className="progress-track">
                  <div
                    className="progress-rail"
                    style={{
                      width: `${item?.value || 0}%`,
                      backgroundColor: getProgressColorCode(item?.color),
                      // backgroundColor: "#456565",
                    }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <hr className="ui-care-plan-report__division"></hr>
    </div>
  );
};

export default CPSRNotes;
